import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import dayjs from 'dayjs';
import { Table } from 'react-bootstrap';

import pointerOnHover from 'lib/css/pointerOnHover';

import StatusPill from './DataSourcesDashboardStatusPill';

function formatDate(date) {
  return date ? dayjs(date).format('MM/DD/YY') : '-';
}

function formatCount(count) {
  return (count ?? 0).toLocaleString('en-US');
}

function DataSourcesDashboardTable({ sources, onRowClick }) {
  return (
    <Table hover className={css(styles.table)}>
      <thead>
        <tr>
          <th>Source</th>
          <th>Type</th>
          <th>Status</th>
          <th>Runs</th>
          <th>Failed</th>
          <th>Last run</th>
          <th>Next run</th>
        </tr>
      </thead>
      {sources.length > 0 ? (
        <tbody>
          {sources.map(source => (
            <tr key={source.id} className={pointerOnHover} onClick={() => onRowClick(source)}>
              <td>{source.source_name}</td>
              <td>{source.source_type}</td>
              <td>
                <StatusPill status={source.status} />
              </td>
              <td>{formatCount(source.total_runs)}</td>
              <td>{formatCount(source.failed_runs)}</td>
              <td>{formatDate(source.last_execution_time)}</td>
              <td>{formatDate(source.next_execution_time)}</td>
            </tr>
          ))}
        </tbody>
      ) : (
        <tbody>
          <tr>
            <td colSpan="100%" className="py-5 text-center">
              No sources match the selected filter
            </td>
          </tr>
        </tbody>
      )}
    </Table>
  );
}

DataSourcesDashboardTable.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRowClick: PropTypes.func.isRequired,
};

const styles = StyleSheet.create({
  table: {
    marginTop: 0,
  },
});

export default DataSourcesDashboardTable;
